import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { UpdateUserModel, GetUserModel } from 'src/app/viewModels/users/UserListModel';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { UserService } from '../services/user/user.service';
import { CommonService } from 'src/app/middleware/common/common.service';
import { RoleService } from '../../roless/services/role.service';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';

@Component({
  selector: 'app-edit-users',
  templateUrl: './edit-users.component.html',
  styleUrls: ['./edit-users.component.scss']
})
export class EditUsersComponent implements OnInit {

  updateUserDetailform: FormGroup;
  updateUserDetail: UpdateUserModel = new UpdateUserModel();
  getUserDetail: GetUserModel = new GetUserModel();
  titleAlert = 'This field is required';
  isEdit: boolean;
  officectrl = new FormControl();
  user: any;
  hide = true;
  roles: any[];
  phoneNumberExt: string;
  updateUserResponseHolder: any;
  rolesResponseHolder: any;
  closePannel:boolean = false;
  getUserListModelEdit={
    search : '',
    pageSize: 10000,
    pageIndex: 0,
    databaseID: 0,
    organizationID: 0
  }
  @Output() closeSidePanel = new EventEmitter();
  @Output() closeSidePanelAfterSave = new EventEmitter();
  organizationID:number=0;
  offices: any;
  searchOffice: any=[];
  selectedOfficeArray: any=[];
  userOffices: any;
  dropdownSettings = {};
  dropdownList: any[] = [];
  selectedItems = [];
  rolesAsssign: any[] = [];
  tempArrayToHoldPermission: any[] = [];
  spinner:boolean=false;
  @Output() getcloseCreateRole = new EventEmitter<boolean>();
  ResponseHolder:any=[]=[];
  selectedUserOrganizationId:number=0;

  constructor(private formBuilder: FormBuilder,private customValidator: CustomvalidationService,
    private _userService: UserService, private commonService: CommonService,
    private encryptionAlgo: EncryptionService,private reusableClass: ReusableClasses, 
    private rolesService: RoleService,private loaderService: LoaderService,
    private toastr: ToastrService,private statusConst: StatusConstant,
    private mulstiselect: MultiselectVM) {
      this.getUserListModelEdit.databaseID = parseInt(sessionStorage.getItem('databaseId'));
      this.getUserListModelEdit.organizationID = parseInt(sessionStorage.getItem('organizationID'));
      this.organizationID = parseInt(sessionStorage.getItem('organizationID'));
     
      let data = [];
      data = this.commonService.getEditData();
      if(data !=undefined){
      this.isEdit = data[0];
      this.user = data[1];
      this.selectedUserOrganizationId =this.user.organizationId; 
      this.getUserDetails();


      // this.updateUserDetail.UUID = this.user.uuid;
      // this.updateUserDetail.FirstName = this.user.firstName;
      // this.updateUserDetail.LastName = this.user.lastName;
      // this.phoneNumberExt = this.user.phoneNumber.substring(0, 2);
      // this.updateUserDetail.PhoneNumber = this.user.phoneNumber.substring(2);
      // this.updateUserDetail.UserRoles = this.user.tempUserRole.split(',');
      // this.updateUserDetail.isActive = this.user.isActive;
          



      // this.user.tempUserRole.forEach(perm => {
      //   let copyModel = Object.assign({}, this.mulstiselect);
      //   copyModel.item_id = perm.roleID;
      //   copyModel.item_text = perm.roleName;
      //   tempArray.push(copyModel);
      // });
      // this.selectedItems = tempArray;

      //this.updateUserDetail.isActive = this.user.isActive === 'Active' ? true : false;
      }      
    this.generateForm();
  }

  ngOnInit(): void {
   this.getOrgOffices();
   this.getUserOffices();
   this.dropdownSettings = {
    singleSelection: false,
    idField: "item_id",
    textField: "item_text",
    enableCheckAll: true,
    allowSearchFilter: true
   };
  }

  getUserDetails() {   
    var ReqModel={
      uuid: this.user.uuid
    }
    this._userService.getUserDetail(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolder = response;
        if(this.ResponseHolder.status == this.statusConst.statusSuccess) {

          this.updateUserDetail.UUID = this.ResponseHolder.data.uuid;
          this.updateUserDetail.isActive = this.ResponseHolder.data.isActive;

          if(this.ResponseHolder.data.firstName != null) {
            this.updateUserDetail.FirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.ResponseHolder.data.firstName);
          }

          if(this.ResponseHolder.data.lastName != null) {
            this.updateUserDetail.LastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.ResponseHolder.data.lastName);
          }          
                 
          if(this.ResponseHolder.data.phoneNumber != null) {
            this.updateUserDetail.PhoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.ResponseHolder.data.phoneNumber);
            this.updateUserDetail.PhoneNumber = this.updateUserDetail.PhoneNumber.substring(2);
          }
          if(this.ResponseHolder.data.phoneNumber != null) {
            this.phoneNumberExt =  this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.ResponseHolder.data.phoneNumber);
            this.phoneNumberExt = this.phoneNumberExt.substring(0, 2);
          }

          this.updateUserDetail.UserRoles=this.ResponseHolder.data.userRoles;
          this.getRolesList();  
        }else{
          this.getRolesList();
        }
      }else{
        this.getRolesList();
      }
    });
  }

  getUserOffices(){
  this._userService.getUserOffices({"organizationID":this.selectedUserOrganizationId,"userID":this.user.uuid}).subscribe(response=>{     
    if (response) {
      this.rolesResponseHolder = response;
      if (this.rolesResponseHolder.status == this.statusConst.statusSuccess) {
        this.userOffices = this.rolesResponseHolder.data;   
        if(this.userOffices.length>0){ 
          
          this.userOffices = Object.values(
            this.userOffices.reduce((a, c) => {
              a[c.officeID] = c;
              return a
            }, {}))

          this.userOffices.forEach(e => {            
           this.selectedOfficeArray.push({"officeName":e.officeName,"officeID":e.officeID});  
          });    
        }
      }
    }
    });
  }

  searchOfficeFun(val) {
    this.searchOffice=[];
      if(val != ''){
      this.searchOffice=this.offices.filter(m=>m.officeName.toLowerCase().includes(val.toLowerCase()));
    }else{
      this.searchOffice=this.offices;
    }
  }

  selectedOffice(o:any){
    if(o.officeID>0){
      var check =[];
      check = this.selectedOfficeArray.filter(m=>m.officeID==o.officeID)
        if(check.length>0){
          this.officectrl.reset();
          this.toastr.warning("Office allready selected", '', {
            timeOut: 3000,
          });
        }else{
          this.selectedOfficeArray.push(o);
          this.officectrl.reset();
        }
       }    
    //   if(!this.selectedOfficeArray.find(m=>m.officeID==o.officeID))
    //    this.selectedOfficeArray.push(o);
    //    this.officectrl.reset();
    // }
    if(this.selectedOfficeArray.length==0){
      this.updateUserDetailform.markAsDirty();
    }
  }
  
  removeSelectedOffice(o:any){
    if(o.officeID>0){
      this.selectedOfficeArray=this.selectedOfficeArray.filter(m=>m.officeID!=o.officeID);
    }
    if(this.selectedOfficeArray.length>0){
      this.updateUserDetailform.markAsDirty();
    }
  }

  getOrgOffices() {
    this._userService.getOrgOffices({"organizationID":this.selectedUserOrganizationId}).subscribe(response=>{
   // this._userService.getOrgOffices({"organizationID":parseInt(sessionStorage.getItem('organizationID'))}).subscribe(response=>{     
      if (response) {
        this.rolesResponseHolder = response;
        if (this.rolesResponseHolder.status == this.statusConst.statusSuccess) {
          this.offices = this.rolesResponseHolder.data;          
        }
      }
      });
  }


  generateForm() {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.updateUserDetailform = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneNumberregex)]],
      userRoles: ['', Validators.required],
      isActive: ''
    });
  }

  get name() {
    return this.updateUserDetailform.get('name') as FormControl;
  }

  getErrorEmail() {
    return this.customValidator.getErrorEmail(this.updateUserDetailform);
  }

  getErrorPassword() {
    return this.customValidator.getErrorPassword(this.updateUserDetailform);
  }

  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.updateUserDetailform);
  }

  equals(objOne, objTwo) {
    if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
      return objOne === objTwo;
    }
  }

  // To allow only alphabets on FirstName and LastName
  checkregex() {
    if (!this.updateUserDetailform.controls['firstname'].value.match(/^[a-zA-Z ]+$/) &&
    this.updateUserDetailform.controls['firstname'].value !== '') {
    this.updateUserDetailform.controls['firstname'].setValue("");
    } else if (!this.updateUserDetailform.controls['lastname'].value.match(/^[a-zA-Z ]+$/) &&
    this.updateUserDetailform.controls['lastname'].value !== '') {
    this.updateUserDetailform.controls['lastname'].setValue("");
    }
    this.titleAlert = 'Please enter only alphabets';
  }


  async updateUser() {
    this.spinner=true;
    this.updateUserDetailform.markAsPristine();
    const updateSelectedDetail = new UpdateUserModel();
    try {
      updateSelectedDetail.UUID = this.updateUserDetail.UUID;
      updateSelectedDetail.FirstName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.updateUserDetail.FirstName);
      updateSelectedDetail.LastName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.updateUserDetail.LastName);
      updateSelectedDetail.PhoneNumber =  this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.phoneNumberExt + '' + this.updateUserDetail.PhoneNumber);
      updateSelectedDetail.isActive = (this.updateUserDetail.isActive !== true) ? false : this.updateUserDetail.isActive;
      updateSelectedDetail.organizationID =Number(this.selectedUserOrganizationId);
      //updateSelectedDetail.organizationID =Number(this.organizationID);           
      this.loaderService.show();
      updateSelectedDetail.UserRoles= [];//this.selectedItems;

      if(this.selectedItems.length>0){
        this.selectedItems.forEach(e => {
          var data=[];
          data =  this.dropdownList.filter(x=>x.item_text==e.item_text);
          if(data.length>0){
            updateSelectedDetail.UserRoles.push((data[0].item_id.toString()));
          }
         });
      }

      // this.selectedItems.forEach(element => {
      //   updateSelectedDetail.UserRoles.push((element.item_id.toString()));
      // //  updateSelectedDetail.UserRoles.push(Number(element.item_id));
      //  });

      // if(this.updateUserDetail.UserRoles){
      //   var userRole=[];
      //   this.updateUserDetail.UserRoles.forEach(e => {
      //     var test= this.roles.find(n=>n.roleName==e)
      //     if(test!=null && test!=undefined){
      //       userRole.push((test.roleID.toString()))
      //     }         
      //    });
      //   }

     // updateSelectedDetail.UserRoles=userRole;
      if(this.selectedOfficeArray){
      this.selectedOfficeArray.forEach(e => {
        if(!updateSelectedDetail.Offices.find(n=>n==e.officeID))
        updateSelectedDetail.Offices.push(e.officeID);
       });
      }
     // return;
      const result = await this._userService.updateUser(updateSelectedDetail).toPromise();
      this.updateUserResponseHolder = result;
      this.loaderService.hide();
      this.spinner=false;
      if (this.updateUserResponseHolder.status === this.statusConst.statusSuccess) {
        this.toastr.success("User updated successfully.", '', {
          timeOut: 3000,
        });
        let closePanel = false;
        this.closeSidePanelAfterSave.emit(closePanel);
        //this._dataSharingService.sendClickEvent();
      } else {
        this.spinner=false;
        this.loaderService.hide();      
      }
    } catch (e) {
      this.spinner=false;
      Observable.throw(e);
    }
  }

  // getUserDetailbyId(data: GetUserModel) {
  //     this._userService.getUserDetail(data).subscribe(result => {
  //     this.updateUserDetail.FirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, result.data.firstName);
  //     this.updateUserDetail.LastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, result.data.lastName);
  //     this.updateUserDetail.PhoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, result.data.phoneNumber);
  //     this.updateUserDetail.isActive = result.data.isActive;
  //     this.generateForm();
  //   });
  // }

  

  close(any) {
    let closePanel = false;
    this.closeSidePanel.emit(closePanel);
    this.getcloseCreateRole.emit(any);
  }

  

  getRolesList(){
    this.loaderService.show();
    this.getUserListModelEdit.organizationID = this.selectedUserOrganizationId;
    this.rolesService.getRoleList(this.getUserListModelEdit).subscribe(response=>{
     if (response) {
      this.rolesResponseHolder = response;
      if (this.rolesResponseHolder.status == this.statusConst.statusSuccess) {
        this.loaderService.hide();
        this.roles = this.rolesResponseHolder.data.roleModel;
        this.dropdownList =this.roles;
        this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
        if(this.rolesAsssign !=null){
          if(this.rolesAsssign?.length > 0){

            this.rolesAsssign = Object.values(
              this.rolesAsssign.reduce((a, c) => {
                a[c.roleID] = c;
                return a
              }, {}))    
              
          //  var min=[];
          //  if(this.rolesAsssign.length==1){
          //   this.dropdownList=this.dropdownList.filter((m) => m.roleLevel >=this.rolesAsssign[0].roleLevel);
          //  }
          //  if(this.rolesAsssign.length>1){
          //   min = this.rolesAsssign.reduce((a, b)=>Math.min(a.roleLevel, b.roleLevel));
          //   this.dropdownList=this.dropdownList.filter((m) => m.roleLevel >=min || m.roleLevel==0);
          //  }          
          
          }
        }  
         this.dropdownList.forEach(perm => {
         let copyModel = Object.assign({}, this.mulstiselect);
          copyModel.item_id = perm.roleID;
          copyModel.item_text = perm.roleName;
          this.tempArrayToHoldPermission.push(copyModel);
        });

        this.dropdownList = this.tempArrayToHoldPermission;          
        let tempArray = [];
        if(this.updateUserDetail.UserRoles){    
          this.updateUserDetail.UserRoles.forEach(e => {
            var test= this.roles.find(n=>n.roleID==Number(e))
            if(test!=null && test!=undefined){
              var check=[];
              check = tempArray.filter(x=>Number(x.item_id) ==test.roleID)
              if(check.length >0){

              }else{
                let copyModel = Object.assign({}, this.mulstiselect);
                copyModel.item_id = test.roleID;
                copyModel.item_text = test.roleName;
                tempArray.push(copyModel);
              }             
            }         
           });
           this.selectedItems = tempArray;
          }
      }
      else{
        this.loaderService.hide();
      }
    }
    else{
      this.loaderService.hide();
    }
    });
  }

}

